var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container"},[_c('MultiChoiceCardsHeader',{scopedSlots:_vm._u([{key:"filters",fn:function(){return [_c('el-button',{attrs:{"type":"primary","icon":"el-icon-refresh","circle":""},on:{"click":_vm.refresh}})]},proxy:true}])}),_c('MultiChoiceCardsList',{ref:"multiChoiceCardsList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }